exports = module.exports = require("../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/node_modules/@angular/cli/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/node_modules/@angular/cli/node_modules/postcss-loader?{"ident":"postcss"}!/Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/styles.css
// module id = ../../node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../node_modules/postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles